/**
 * Import a stylesheet from a URL
 * it helps to add external stylesheets to the standalone components - dynamically (at constructor)
 * @param stylesheetUrl
 * @example
 * ```ts
 * constructor() {
 * 	importStylesFrom('https://cdn.jsdelivr.net/npm/jsoneditor/dist/jsoneditor.min.css');
 * }
 * ```
 */
export function importStylesFrom(stylesheetUrl: string): void {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = stylesheetUrl;
	document.head.appendChild(link);
}
